<div class="row mt-2 mb-2">
  <div class="col-8 col-lg-4">
    <p class="teaching__digits">
      <span class="teaching__legend_mute">Всего просмотров: </span>
      <span class="counter">{{ viewsCount }} </span>
      <span class="teaching__legend_mute">шт.</span>
    </p>
  </div>
  <div class="col-8 col-lg-4">
    <p class="teaching__digits">
      <span class="teaching__legend_mute">Среднее время просмотра: </span>
      <span class="counter">{{ viewsTimeAverage }} </span>
      <span class="teaching__legend_mute">с.</span>
    </p>
  </div>
</div>
<form [formGroup]="form">
  <div class="row mb-2">
    <div class="col-12">
      <div class="mb-2">
        <div class="row no-gutters align-items-center justify-content-between m-0">
          <div class="flex-grow-1 col-12 col-lg-8">
            <div class="d-flex flex-row-reverse flex-nowrap justify-content-between align-items-center">
              <div>
                <app-material-input-datepicker
                  formControlName="date_to"
                  [placeholder]="'Создана до'"
                  [cssClass]="'mb-0'"
                ></app-material-input-datepicker>
              </div>
              <div>
                <app-material-input-datepicker
                  formControlName="date_from"
                  [placeholder]="'Создана с'"
                  [cssClass]="'mb-0'"
                ></app-material-input-datepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
@if (actionViewsRows.length) {
  Всего: <b> {{ actionViewsRows.length }}</b>
}
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        <th>Дата просмотра</th>
        <th>Организация</th>
        <th>Агент</th>
        <th>Время просмотра</th>
      </tr>
      @if (actionViewsRows.length) {
        @for (row of actionViewsRows; track row) {
          <tr>
            <td>{{ row.view_date }}</td>
            <td>
              <a [routerLink]="['/entity/edit', row.view_org_id, 'common']">
                {{ row.view_org_caption }}
              </a>
            </td>
            <td>
              <a [routerLink]="['/physical/edit', row.view_user_id, 'common']">
                {{ row.view_user_fio }}
              </a>
            </td>
            <td> {{ row.duration }}</td>
          </tr>
        }
      }
      @if (!actionViewsRows.length) {
        <tr>
          <td colspan="4">
            Нет данных для отображения
          </td>
        </tr>
      }
    </table>
  </div>
</div>

